import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import SalesOrderingDialog from './sales-ordering-dialog';
import { SalesOrderingMainProps } from '../../models/sales-ordering/sales-ordering-model';

const SalesOrderingMain: React.FC<SalesOrderingMainProps> = ({ visible, onHide }) => {
    const toast = useRef<Toast>(null);

    return (
        <>
            <Toast ref={toast} />
            <SalesOrderingDialog
                visible={visible}
                onHide={onHide}
                toast={toast}
            />
        </>
    );
};

export default SalesOrderingMain;
